import {Resolve, RouterStateSnapshot, ActivatedRouteSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Kursant} from './kursant';
import {KursanciService} from './kursanci.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class KursantResolver implements Resolve<Kursant> {

    constructor(private kursanciService: KursanciService) { }

    resolve(
        route: ActivatedRouteSnapshot, 
        state: RouterStateSnapshot): Observable<Kursant> {

        return this.kursanciService.findKursantByKey(route.params['key'])
            .snapshotChanges().map(action => {
              const data = action.payload.val() as Kursant;
              const key = action.payload.key;
              return { key, ...data };
            })
            .first()
            // .do( res => console.log('Resolver:', res))
    }
}



// WEBPACK FOOTER //
// ./src/app/services/kursant.resolver.ts